import * as React from 'react';
import styles from './Page.module.scss';

export const Page = ({ children, className, innerRef }: React.PropsWithChildren<{ className?: string, innerRef?: any }>) => (
    <div className={`${styles.page} ${className || ''}`} ref={innerRef}>{children}</div>
);
